import { render, staticRenderFns } from "./vehicle_basicinfo.vue?vue&type=template&id=a8b0d8da&scoped=true"
import script from "./vehicle_basicinfo.vue?vue&type=script&lang=js"
export * from "./vehicle_basicinfo.vue?vue&type=script&lang=js"
import style0 from "./vehicle_basicinfo.vue?vue&type=style&index=0&id=a8b0d8da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_77a37368fa9f7d737cecfb85aa182826/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8b0d8da",
  null
  
)

export default component.exports